import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { ListRequestQuery, WSServiceError } from "../../utils/serviceHelper";
import { getPlanEnrollments } from "../../services/api/planEnrollment/getPlanEnrollments";
import { IPlanEnrollmentListQueryFilter } from "../../services/api/planEnrollment/types";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentListQuerySort = NonNullable<
  planEnrollmentApiSpec.operations["listPlanEnrollments"]["parameters"]["query"]
>["sort"];

export const QUERY_BENEFITS_PLAN_ENROLLMENTS =
  "QUERY_BENEFITS_PLAN_ENROLLMENTS";

/**
 * TODO(v3-blocker): plan enrollments have no implemented v3 home, so this stays
 * on the retired `/v2/plan-enrollment` read and throws `NotMigrated`.
 *
 * Every candidate v3 resource answers 501 `NotImplemented` on integration:
 * `GET /v3/platform/benefit-enrollments` (and the Person-scoped
 * `GET /v3/platform/persons/:personId/benefit-enrollments`),
 * `GET /v3/platform/benefit-plans`, `GET /v3/platform/purchase-catalog`,
 * `GET /v3/platform/purchases` and the whole `/v3/platform/subscription*`
 * family.
 *
 * The v3 model can't express these products yet either: `BenefitPlanType` admits
 * only Health/Dental/Vision/Life/Disability/Retirement/Other, and `CatalogItem`
 * (category `Insurance`) carries no stable plan-type key to filter on — only an
 * id and a name. Rewrite this read against whichever resource ships, rather than
 * shimming the v1 shape.
 */
export const useQueryPlanEnrollments = (
  params: ListRequestQuery<
    IPlanEnrollmentListQueryFilter,
    IPlanEnrollmentListQuerySort
  >,
  config?: WSQueryConfig<IPlanEnrollment[], WSServiceError>
) =>
  useWSQuery(
    [QUERY_BENEFITS_PLAN_ENROLLMENTS, params],
    () => getPlanEnrollments(params),
    config
  );
